export interface SupportedObject {
  name: string
  label: string
  required: boolean
}

export const FORM_UI_WIDGET_TYPE_TO_FORM_FIELD_TYPE_MAPPING: Record<string, string> = {
  USDateInputWidget: 'date',
  SSNInputWidget: 'ssn',
  ITINInputWidget: 'itin',
  CurrencyWidget: 'currency',
  PercentageWidget: 'percentage',
  PhoneNumberWidget: 'phoneNumber',
  SingleChoiceWidget: 'singleChoice',
  MultipleChoiceWidget: 'multipleChoice',
}

export const FORM_FIELD_TYPE_TO_FORM_FIELD_LABEL_MAPPING: Record<string, string> = {
  string: 'Text',
  boolean: 'Yes/No',
  number: 'Number',
  date: 'Date',
  currency: 'Currency',
  percentage: 'Percentage',
  phoneNumber: 'Phone Number',
  ssn: 'SSN',
  itin: 'ITIN',
  singleChoice: 'Single Choice',
  multipleChoice: 'Multiple Choice',
  array: 'List',
}
